// Dictionnaires de traduction de l'interface (hors phrases aléatoires, voir data/comments.js).
// Clés pointées (ex. "slot.spin"), avec {paramètres} substitués par core/i18n.js#translate.
export const translations = Object.freeze({
  fr: {
    // Pieds de page : « Zero Maze v{version} · un jeu 0cog™ » en bas de tous les écrans ; l'écran d'accueil ajoute
    // licence et marque. Toujours ™ : la marque 0cog n'est pas enregistrée.
    legal: {
      product: 'Zero Maze v{version}',
      licensed: 'Édité et distribué par 0cog sous licence exclusive.',
      trademark: '0cog™ est une marque de 0cog',
    },
    brand: { line: 'un jeu 0cog™' },
    meta: {
      lang: 'fr',
      description: 'ZERO MAZE — sois le premier à trouver le fromage dans le labyrinthe néon.',
    },
    app: { subtitle: 'Tire ton duel, puis fonce sur l\'action.' },
    splash: { subtitle: 'Tire ton duel, puis fonce sur l\'action.' },
    install: {
      launchPopup: {
        message: "Installer le jeu sur l'écran d'accueil",
        yes: 'Oui',
        later: 'Plus tard',
      },
      hint: {
        title: 'Installer le jeu',
        step1Before: 'Appuie sur le bouton',
        step1Bold: 'Partager',
        step1After: '',
        step1Location: ", près de la barre d'adresse de Safari.",
        step2Before: 'Choisis',
        step2Bold: "« Sur l'écran d'accueil »",
        step3Before: 'Confirme avec',
        step3Bold: 'Ajouter',
        footnote: "Une fois installé sur ton écran d'accueil, le jeu s'ouvrira en plein écran, comme une application.",
      },
    },
    scoreboard: {
      level: 'Niveau Labyrinthe', gain: 'Gagne', score: 'Ton Score', points: 'pts',
      // Annonce au-dessus du gain, après une paire au bandit manchot (ui/scoreboard.js)
      multiplier: 'Gain ×{multiplier}',
    },
    // Hall of Fame (ui/leaderboardView.js) : trois onglets, comme le bloc « Meilleurs joueurs » d'apps.0cog.com
    leaderboard: {
      buttonTitle: 'Hall of Fame',
      title: 'Hall of Fame',
      tab: { week: 'Top de la semaine', month: 'Top du mois', all: 'Le top du top' },
      empty: 'Personne encore : gagne les 8 labyrinthes pour ouvrir le bal !',
      updated: 'Mis à jour le {date}',
    },
    share: {
      buttonTitle: 'Partager',
      modal: {
        title: 'Partage le jeu',
        hint: 'Flasher le QR Code pour installer le jeu',
      },
    },
    music: { toggleTitle: 'Musique', volumeDown: 'Son -', volumeUp: 'Son +' },
    // Profil, comme ZERO SLANG : avatar, pseudo et position (pays, ville), dans la fenêtre du bouton de compte (ui/profileView.js)
    profile: {
      title: 'Ton profil',
      pseudoPlaceholder: 'Ton pseudo...',
      avatarLabel: 'Ton avatar',
      avatar: {
        fox: 'Renard', frog: 'Grenouille', unicorn: 'Licorne', alien: 'Extraterrestre', ghost: 'Fantôme', panda: 'Panda',
        robot: 'Robot', octopus: 'Pieuvre', cat: 'Chat', lion: 'Lion', dino: 'Dinosaure', cool: 'Lunettes de soleil',
      },
      place: {
        share: '📍 Partager ma position',
        locating: 'Localisation…',
        found: '📍 {place}',
        relocate: 'Touche ta ville pour te relocaliser.',
        required: 'Sans ta position, ton score reste sur cet appareil.',
        denied: 'Position refusée : ton score restera sur cet appareil.',
        unknown: 'Lieu introuvable : ton score restera sur cet appareil.',
      },
      save: 'Enregistrer',
      // Fin de partie : le joueur inscrit son score au Hall of Fame (ui/profileView.js, open({ register: true }))
      register: {
        title: 'Prétendant au Hall of Fame',
        sub: '{score} pts à inscrire à ton nom',
        save: 'Inscrire mon score',
      },
      chip: { guest: 'Créer ton profil', named: 'Profil : {pseudo}' },
      error: {
        invalidChars: 'Lettres, chiffres, "_" et "-" uniquement, sans espace.',
        tooShort: 'Au moins {min} caractères.',
        tooLong: 'Au plus {max} caractères.',
        nameTaken: 'Cet avatar et ce pseudo sont déjà pris au Hall of Fame : change l’un des deux.',
      },
    },

    close: { aria: 'Fermer' },
    overlay: {
      button: { start: 'Jouer', win: 'Niveau suivant', survive: 'Réessayer', lose: 'Recommencer', champion: 'Inscrire mon score' },
    },
    // Bandit manchot (ui/slotMachine.js). Phrase de chaque action avec son objet : {a} la fait à {b}
    // (« 🐭 prend le ❤️ de 🐱 »), dans un sens ou dans l'autre selon le résultat (core/slot.js#castParams).
    slot: {
      spin: 'Nouvelle partie',
      play: 'Jouer',
      respin: 'Relancer',
      // Tirage bonus : trois personnages au lieu de deux et une action (core/slot.js#drawSpin). {multiplier} : le gain
      // multiplié par les paires ; {points} : ce que le triple ajoute au score.
      bonus: {
        none: "Trois personnages, pas d'action : relance !",
        pair: 'Une paire ! Gain doublé : ×{multiplier}',
        triple: 'Triple ! +{points} pts sur ton score',
      },
      // Fin de niveau : le premier arrivé sur l'action la fait à l'autre (picto de l'action autour)
      result: {
        win: '{goal} {sentence} ! {goal}',
        survive: '{goal} De justesse : {sentence}… {goal}',
        lose: '{goal} Trop tard : {reverse} ! {goal}',
        // Dernier niveau gagné (FINAL_LEVEL) : la partie est gagnée, le score peut entrer au Hall of Fame
        champion: '🏆 Les {levels} labyrinthes sont vaincus ! Avec {score} pts, te voilà prétendant au Hall of Fame. 🏆',
      },
      action: {
        love: { label: 'aimer', phrase: '{a} prend le {goal} de {b}' },
        fight: { label: 'se battre', phrase: '{a} met un {goal} à {b}' },
        kiss: { label: 'embrasser', phrase: '{a} vole un {goal} à {b}' },
        hug: { label: 'câliner', phrase: '{a} fait un {goal} à {b}' },
        scare: { label: 'effrayer', phrase: '{a} arrache un {goal} à {b}' },
        tickle: { label: 'chatouiller', phrase: '{a} passe la {goal} sous le nez de {b}' },
        dance: { label: 'danser', phrase: '{a} fait danser {b} sur la {goal}' },
      },
    },
    // Scénarios par action (core/scenarios/) : règle affichée au tirage, bulles d'aide, phrases de fin
    // (scenario.<id>.<cause>, sinon slot.result.<résultat>). Paramètres : {player} {rival} {goal}, et la
    // phrase de l'action {sentence} (le joueur la fait à l'adversaire) ou {reverse} (l'inverse).
    scenario: {
      race: {
        rule: "Tu joues {player}, atteins {goal} avant {rival} !",
        hint: {
          goal: "{goal} L'action convoitée : atteins-la avant {rival} pour empocher tous les points !",
          rival: "{rival} file tout seul vers {goal}… Il t'attend : bouge pour lancer la course !",
        },
      },
      love: {
        rule: 'Tu joues {player}, va à la rencontre de {rival} avant que le {goal} se vide !',
        hint: { rival: '{rival} vient vers toi, mais son {goal} se vide : cours à sa rencontre !' },
        win: '{goal} Rendez-vous réussi : {sentence} ! {goal}',
        timeout: "💔 Le cœur s'est vidé : rendez-vous manqué avec {rival}… 💔",
      },
      fight: {
        rule: 'Tu joues {player}, ramasse le {goal} avant que {rival} te tombe dessus, puis frappe !',
        hint: {
          goal: '{goal} Ton gant : sans lui, ne te laisse surtout pas toucher !',
          rival: "{rival} fonce sur toi. Une fois ganté, c'est lui qui fuira !",
        },
        win: '{goal} K.-O. : {sentence} ! {goal}',
        beaten: '{goal} Pris sans gant : {reverse} ! {goal}',
        timeout: "⏱️ Fin du round : {rival} a esquivé jusqu'au bout… ⏱️",
      },
      kiss: {
        rule: "Tu joues {player}, vole un {goal} à {rival} avant qu'il change de cachette !",
        hint: { rival: "{rival} t'attend… pas longtemps : quand il s'efface, il va filer ailleurs !" },
        win: '{goal} Smack ! {sentence} ! {goal}',
        timeout: "🙈 {rival} t'a filé entre les pattes trop de fois… 🙈",
      },
      hug: {
        rule: 'Tu joues {player}, retrouve {rival} perdu dans le noir et fais-lui un {goal} !',
        hint: { rival: '{rival} est perdu dans le noir : il appelle de temps en temps, suis son signal !' },
        win: '{goal} Retrouvé : {sentence} ! {goal}',
        timeout: '🌑 {rival} est resté seul dans le noir… 🌑',
      },
      scare: {
        rule: 'Tu joues {player}, approche {rival} par derrière sans être vu et arrache-lui un {goal} !',
        hint: { rival: "{rival} fait sa ronde et regarde droit devant (cases jaunes) : surprends-le sans qu'il te voie !" },
        win: '{goal} Bouh ! {sentence} ! {goal}',
        spotted: "👀 Repéré ! {rival} t'a vu venir… 👀",
        timeout: '⏱️ {rival} a fini sa ronde sans avoir eu peur… ⏱️',
      },
      tickle: {
        rule: 'Tu joues {player}, ramasse toutes les {goal}, puis chatouille {rival} !',
        hint: {
          goal: '{goal} Ramasse toutes les plumes du labyrinthe…',
          rival: "{rival} n'est chatouilleux qu'une fois toutes les plumes ramassées !",
        },
        win: '{goal} Guili-guili : {sentence} ! {goal}',
        timeout: '⏱️ Pas assez de plumes, {rival} garde son sérieux… ⏱️',
      },
      dance: {
        rule: "Tu joues {player}, avance vers {rival} quand la {goal} joue et fige-toi quand elle s'arrête !",
        hint: { rival: "{rival} danse au bout du labyrinthe. Quand la musique s'arrête ✋, ne bouge plus, sinon retour au départ !" },
        win: '{goal} En rythme : {sentence} ! {goal}',
        timeout: '⏱️ La piste ferme, {rival} danse seul… ⏱️',
      },
    },
    playHint: {
      mouseTouch: "{player} C'est toi ! Pose ton doigt sur moi et fais-moi glisser dans les couloirs.",
      mouseDesktop: "{player} C'est toi ! Fais-moi glisser (clic maintenu), avance avec les flèches, ou glisse à deux doigts sur le trackpad.",
    },
    dev: {
      title: 'Réglages Dev',
      language: { label: 'Langue', fr: 'Français', en: 'English' },
      mazeGrowth: { label: 'Croissance Taille Labyrinthe', min: 'Lente (+1/niv)', max: 'Rapide (+10/niv)' },
      twistiness: { label: 'Complexité du Chemin', min: 'Lignes droites', max: 'Très tortueux' },
      timerSpeed: { label: 'Vitesse du Timer (x)', min: 'x0.2 (Facile)', max: 'x5.0 (Dur)' },
      bpm: { label: 'Tempo Musique (BPM)', min: 'Lent (60)', max: 'Rapide (240)' },
      startLevel: { label: 'Niveau de Départ', min: 'Niveau 1', max: 'Niveau 8' },
      deadEnds: { label: 'Impasses (Culs-de-sac)', min: 'Aucune (Boucles)', max: '100% (Classique)' },
      playerSpeed: { label: 'Vitesse Souris (Glissement)', min: 'Très Rapide (10 px)', max: 'Lente (60 px)' },
      warning: '⚠️ Dès qu\'un réglage est appliqué, les scores de la session ne sont plus envoyés au classement en ligne (mode local uniquement).',
      apply: 'Relancer le jeu',
    },
  },
  en: {
    legal: {
      product: 'Zero Maze v{version}',
      licensed: 'Published and distributed by 0cog under exclusive license.',
      trademark: '0cog™ is a trademark of 0cog',
    },
    brand: { line: 'a 0cog™ game' },
    meta: {
      lang: 'en',
      description: 'ZERO MAZE — be the first to find the cheese in the neon maze.',
    },
    app: { subtitle: 'Spin your duel, then race to the action.' },
    splash: { subtitle: 'Spin your duel, then race to the action.' },
    install: {
      launchPopup: {
        message: 'Install the game on your Home Screen',
        yes: 'Yes',
        later: 'Later',
      },
      hint: {
        title: 'Install the game',
        step1Before: 'Tap the',
        step1Bold: 'Share',
        step1After: 'button',
        step1Location: ", near Safari's address bar.",
        step2Before: 'Choose',
        step2Bold: '"Add to Home Screen"',
        step3Before: 'Confirm with',
        step3Bold: 'Add',
        footnote: 'Once installed on your Home Screen, the game will open full-screen, just like an app.',
      },
    },
    scoreboard: {
      level: 'Maze Level', gain: 'Win', score: 'Your Score', points: 'pts',
      multiplier: 'Gain ×{multiplier}',
    },
    leaderboard: {
      buttonTitle: 'Hall of Fame',
      title: 'Hall of Fame',
      tab: { week: 'Top of the week', month: 'Top of the month', all: 'All-time top' },
      empty: 'Nobody yet: beat the 8 mazes to open the ball!',
      updated: 'Updated {date}',
    },
    share: {
      buttonTitle: 'Share',
      modal: {
        title: 'Share the game',
        hint: 'Scan the QR Code to install the game',
      },
    },
    music: { toggleTitle: 'Music', volumeDown: 'Volume -', volumeUp: 'Volume +' },
    profile: {
      title: 'Your profile',
      pseudoPlaceholder: 'Your nickname...',
      avatarLabel: 'Your avatar',
      avatar: {
        fox: 'Fox', frog: 'Frog', unicorn: 'Unicorn', alien: 'Alien', ghost: 'Ghost', panda: 'Panda',
        robot: 'Robot', octopus: 'Octopus', cat: 'Cat', lion: 'Lion', dino: 'Dinosaur', cool: 'Sunglasses',
      },
      place: {
        share: '📍 Share my location',
        locating: 'Locating…',
        found: '📍 {place}',
        relocate: 'Tap your city to locate yourself again.',
        required: 'Without your location, your score stays on this device.',
        denied: 'Location denied: your score will stay on this device.',
        unknown: 'Place not found: your score will stay on this device.',
      },
      save: 'Save',
      register: {
        title: 'Hall of Fame contender',
        sub: '{score} pts to sign with your name',
        save: 'Enter my score',
      },
      chip: { guest: 'Create your profile', named: 'Profile: {pseudo}' },
      error: {
        invalidChars: 'Letters, digits, "_" and "-" only, no spaces.',
        tooShort: 'At least {min} characters.',
        tooLong: 'At most {max} characters.',
        nameTaken: 'This avatar and nickname are already taken in the Hall of Fame: change one of them.',
      },
    },

    close: { aria: 'Close' },
    overlay: {
      button: { start: 'Play', win: 'Next level', survive: 'Retry', lose: 'Restart', champion: 'Enter my score' },
    },
    slot: {
      spin: 'New game',
      play: 'Play',
      respin: 'Spin again',
      bonus: {
        none: 'Three characters, no action: spin again!',
        pair: 'A pair! Gain doubled: ×{multiplier}',
        triple: 'Triple! +{points} pts on your score',
      },
      result: {
        win: '{goal} {sentence}! {goal}',
        survive: '{goal} Just in time: {sentence}… {goal}',
        lose: '{goal} Too late: {reverse}! {goal}',
        champion: '🏆 All {levels} mazes conquered! With {score} pts, you are a Hall of Fame contender. 🏆',
      },
      action: {
        love: { label: 'love', phrase: "{a} steals {b}'s {goal}" },
        fight: { label: 'fight', phrase: '{a} lands a {goal} on {b}' },
        kiss: { label: 'kiss', phrase: '{a} steals a {goal} from {b}' },
        hug: { label: 'hug', phrase: '{a} gives {b} a {goal}' },
        scare: { label: 'scare', phrase: '{a} gets a {goal} out of {b}' },
        tickle: { label: 'tickle', phrase: '{a} tickles {b} with a {goal}' },
        dance: { label: 'dance', phrase: '{a} makes {b} dance to the {goal}' },
      },
    },
    scenario: {
      race: {
        rule: 'You play {player}, reach {goal} before {rival}!',
        hint: {
          goal: '{goal} The coveted action: reach it before {rival} to score every point!',
          rival: "{rival} runs to {goal} all by itself… It's waiting for you: move to start the race!",
        },
      },
      love: {
        rule: 'You play {player}, go and meet {rival} before the {goal} runs dry!',
        hint: { rival: '{rival} is coming to you, but its {goal} is running dry: run to meet it!' },
        win: '{goal} Date on: {sentence}! {goal}',
        timeout: '💔 The heart ran dry: missed date with {rival}… 💔',
      },
      fight: {
        rule: 'You play {player}, grab the {goal} before {rival} gets you, then strike!',
        hint: {
          goal: "{goal} Your glove: without it, don't let it touch you!",
          rival: "{rival} is charging at you. Once you've got the glove, it will run!",
        },
        win: '{goal} Knockout: {sentence}! {goal}',
        beaten: '{goal} Caught without a glove: {reverse}! {goal}',
        timeout: '⏱️ End of the round: {rival} dodged until the bell… ⏱️',
      },
      kiss: {
        rule: 'You play {player}, steal a {goal} from {rival} before it hides elsewhere!',
        hint: { rival: "{rival} is waiting… not for long: when it fades away, it's about to vanish!" },
        win: '{goal} Smooch! {sentence}! {goal}',
        timeout: '🙈 {rival} slipped away too many times… 🙈',
      },
      hug: {
        rule: 'You play {player}, find {rival} lost in the dark and give it a {goal}!',
        hint: { rival: '{rival} is lost in the dark: it calls out now and then, follow its signal!' },
        win: '{goal} Found: {sentence}! {goal}',
        timeout: '🌑 {rival} stayed alone in the dark… 🌑',
      },
      scare: {
        rule: 'You play {player}, sneak up on {rival} from behind, unseen, and get a {goal} out of it!',
        hint: { rival: '{rival} is on patrol and looks straight ahead (yellow cells): surprise it without being seen!' },
        win: '{goal} Boo! {sentence}! {goal}',
        spotted: '👀 Spotted! {rival} saw you coming… 👀',
        timeout: '⏱️ {rival} finished its rounds without a fright… ⏱️',
      },
      tickle: {
        rule: 'You play {player}, pick up every {goal}, then tickle {rival}!',
        hint: {
          goal: '{goal} Pick up every feather in the maze…',
          rival: '{rival} is only ticklish once you have every feather!',
        },
        win: '{goal} Tickle tickle: {sentence}! {goal}',
        timeout: '⏱️ Not enough feathers, {rival} keeps a straight face… ⏱️',
      },
      dance: {
        rule: 'You play {player}, move toward {rival} while the {goal} plays and freeze when it stops!',
        hint: { rival: "{rival} is dancing at the end of the maze. When the music stops ✋, don't move, or it's back to the start!" },
        win: '{goal} In rhythm: {sentence}! {goal}',
        timeout: '⏱️ The dance floor is closing, {rival} dances alone… ⏱️',
      },
    },
    playHint: {
      mouseTouch: "{player} That's you! Put your finger on me and drag me through the corridors.",
      mouseDesktop: "{player} That's you! Drag me (click and hold), use the arrow keys, or swipe with two fingers on the trackpad.",
    },
    dev: {
      title: 'Dev Settings',
      language: { label: 'Language', fr: 'Français', en: 'English' },
      mazeGrowth: { label: 'Maze Size Growth', min: 'Slow (+1/lvl)', max: 'Fast (+10/lvl)' },
      twistiness: { label: 'Path Complexity', min: 'Straight lines', max: 'Very twisty' },
      timerSpeed: { label: 'Timer Speed (x)', min: 'x0.2 (Easy)', max: 'x5.0 (Hard)' },
      bpm: { label: 'Music Tempo (BPM)', min: 'Slow (60)', max: 'Fast (240)' },
      startLevel: { label: 'Start Level', min: 'Level 1', max: 'Level 8' },
      deadEnds: { label: 'Dead Ends', min: 'None (Loops)', max: '100% (Classic)' },
      playerSpeed: { label: 'Mouse Speed (Swipe)', min: 'Very Fast (10 px)', max: 'Slow (60 px)' },
      warning: "⚠️ Once a setting is applied, this session's scores are no longer sent to the online leaderboard (local mode only).",
      apply: 'Restart the game',
    },
  },
});
